// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2026-05-12T12:07:25+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  192125
//    Project:        617
//    Environment:    7626 - master
//    MD5:            fa013d1fb1c796f27c6d200a192d0a96
//    Signature:      eyJpdiI6IkVDdnozRlZGNStTejdWZnYrbXVyXC9RPT0iLCJ2YWx1ZSI6IlhId2RlM2RDbWw4SzByeENcL21NV2t1QWc4WjlSQkpydjV3ZTIzUWhqVXlhekxJRkNvKzl1eWNSR1hCcTZISjVrekVjRzF3OUVMSE5SalRRSVBYclN4VDdIQlFQSVhZbG1jZGtMWDRTOUUxXC9WVmRzMVFPNm9CTW9pQzBicCt0a0dSK2NBbFkrSjdCYjhmTXJwNEtaUysrTjErY1hjWXdORGFCVnI3Q0lPdzg3Q0dDdFFMTUN1UWhFVEF5RDhEMFljOUVKdThWek1EYkNEcEM5WUNjbGVybHdnS3RJXC9GZzJGZlhiTmtXY215Vm5MY0J6NE5SV04yWkZiVzllRGs3NkI2anlyaW1nV0phdEp0em1mU2RSNUl5OXJkMGs2YWhrb282MURrcFlIaG5yMTZreXlGSnhablR3RCtDM0RrdFwvYUFlUWNWXC9sUGxZR3BzWGYxbm9xUjMxak56dHdcL280b0phVW1PNHJhcElSajZyRTBvWU1jSHowa0J0ZlBDTkdaS3crQzFUQ2NQY0k0NXVvUW5qSU9BaHc9PSIsIm1hYyI6IjBiMzRhYWQ2MmMwODY3NTUyOGNiNGJkYzc3NDRjODc4NTM5NGVmN2Y3ZmMyYTZmNzlhNTkwY2EyYWZjNjQxNmQifQ==
if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('button');
        button.addEventListener('click', (event) => {
          this.expandShowMore(event);
          const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item');
          if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden') && nextElementToFocus.querySelector('input')) {
            nextElementToFocus.querySelector('input').focus();
          }
        });
      }
      expandShowMore(event) {
        const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
        const parentWrap = parentDisplay.querySelector('.parent-wrap');
        this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
        parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));
        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }
      }
    }
  );
}
